// removed by extract-text-webpack-plugin
module.exports = {"pageSectionForm":"_2BSER"};